import classNames from 'classnames';
import { ReactNode } from 'react';

interface IButtonDescriptionProps {
  description: ReactNode;
  position?: 'left' | 'bottom' | 'right' | 'top';
}

const ButtonDescription = ({ description, position = 'bottom' }: IButtonDescriptionProps) => {
  const className = classNames(['button-description', position]);
  return (
    <div className={className}>
      <p>{description}</p>
    </div>
  );
};

export default ButtonDescription;
